import { get, post, type RequestOptions } from '@/api/client';
import type {
  PublicUrgencyGateResponse,
  PublicUrgencyPageResponse,
  PublicUrgencyVerifyInput,
  PublicUrgencyVerifyResponse,
} from './types';

export const publicUrgencyApi = {
  getGate: (token: string, options?: RequestOptions) =>
    get<PublicUrgencyGateResponse>(`/api/public/urgency/${token}`, undefined, options),

  verifyDob: (token: string, data: PublicUrgencyVerifyInput) =>
    post<PublicUrgencyVerifyResponse>(`/api/public/urgency/${token}/verify-dob`, data),

  getPage: (token: string, options?: RequestOptions) =>
    get<PublicUrgencyPageResponse>(`/api/public/urgency/${token}/page`, undefined, options),
};
